<template>
  <div class="container" style="background:#fff;padding:0px; ">
      <topOp > </topOp>
      <div class="row">
        <div class="col-md-12">
          <div class="horasExtras">
            <h3 style="font-style:italic;">
              Remuneração de Férias
            </h3>
           <div class="formAjuste4" >
             <p style="text-align:left;margin-bottom:-11px;padding:0px;">Salário Mensal<p>  
             <label class="sr-only" >Mes</label>  
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="material-icons" style="font-size:16px;color:#808080;">attach_money</i></div>
                </div>
                  <money  class="form-control formatacaoInput" v-model="salarioBruto" v-bind="money" @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money> 
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Média de Variáveis<p>                           
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class='fas fa-star-of-life' style="color:#808080;"></i></div>
                </div>  
                <money  class="form-control formatacaoInput" v-model="mediaVariaveis1" v-bind="money"></money>   
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Dependentes para o Imposto de Renda<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class='fas fa-user-alt' style="font-size:16px;color:#808080;"></i></div>
                </div>
                 <input type="text" class="form-control formatacaoInput" v-model="dependentes" />
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Dias de Gozo de Férias<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><img src="../assets/tsunami.svg" style="width:16px;"></div>
                </div>
                <input type="text" class="form-control formatacaoInput" v-model="gozoFerias">
              </div>
              <div style="text-align:left;padding:0px;">
                   <div  v-if="exibir" style="text-align:left;margin-top:21px;">                  
                <div @click="desabilitar" style="width: 25px; cursor:pointer; 
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;margin-bottom:10px;"><i class="fa fa-check"  style="font-size:17px;margin-left:3px;"></i></div> Abono Pecuniário                  
              </div>
              <div @click="desabilitar" v-else  style="text-align:left;margin-top:21px;"> 
                <div style="width: 25px; cursor:pointer;
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;margin-bottom:10px;"><span style="font-size:1px;">.</span></div> Abono Pecuniário              
              </div>          
                </div>          
              <div v-if="!exibir" class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-calendar" style="color:#808080;"></i></div>
                </div>
                <input class="form-control formatacaoInput" v-model="abonoPecuniario"  disabled>
              </div>
               <div v-else class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-calendar" style="font-size:16px;color:#808080;"></i></div>
                </div>
             <input  class="form-control formatacaoInput" v-model="abonoPecuniario" >
              </div>
            <div  v-if="exibir2" style="text-align:left;margin-top:21px;">                  
                <div @click="desabilitar2" style="width: 25px; cursor:pointer; 
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;margin-bottom:10px;"><i class="fa fa-check"  style="font-size:17px;margin-left:3px;"></i></div> Adiantar 1ª parcela 13º Salário
<p style="text-align:left;margin-bottom:-11px;padding:0px;">Média de  Variáveis</p>    <br>   
 <div v-if="exibir2" class="input-group mb-3 mr-sm-2">
              <div class="input-group mb-3 mr-sm-2" style="margin-bottom: 2rem;">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class='fas fa-star-of-life' style="color:#808080;"></i></div>
                </div>
                  <money  class="form-control formatacaoInput" v-model="mediaVariaveis2" v-bind="money"></money> 
              </div> 
              </div>            
              </div>
              <div v-else  @click="desabilitar2"  style="text-align:left;margin-top:21px;"> 
                <div style="width: 25px; cursor:pointer;
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;margin-bottom:10px;"><span style="font-size:1px;">.</span></div> Adiantar 1ª parcela 13º Salário 
<p style="text-align:left;margin-bottom:-11px;padding:0px;">Média de  Variáveis</p> <br>   
 <div v-if="!exibir2" class="input-group mb-3 mr-sm-2">                          
              <div class="input-group mb-3 mr-sm-2" style="margin-bottom: 2rem;">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class='fas fa-star-of-life' style="color:#808080;"></i></div>
                </div>
                  <money  class="form-control formatacaoInput" v-model="mediaVariaveis2" v-bind="money" disabled></money> 
              </div> 
              </div>         
              </div>              
              <br>              
              <button class="limpar" @click="limpar()">Limpar</button> <a href="#horasExtrasResultado1"><button :disabled="disabled" class="calcular" @click="calcular()" >calcular <b-spinner v-show="spiner" style="width: 1.5rem;
height: 1.5rem;" small></b-spinner></button></a>
              <br>
              <br>
              <span style="color:red;" v-show="erro">Erro no cálculo. Por favor revise os campos!</span>
              <br>
            </div>
          </div>
        </div>
      </div>
      <div class="horasExtrasResultado" id="horasExtrasResultado1"  style="background:#BEBEBE;">
            <h3 style="font-style:italic;">
              Resultado do Cálculo
            </h3>  
             <div class="row" > 
                <div class="col-md-6 col-sm-6">
                    <p class="pResult">Férias Gozadas:</p>
                    <input type="text" class="inputResult" :value="resultadoValorFerias" disabled>
                    <p class="pResult">  1/3 Férias Gozadas:</p>
                    <input type="text" class="inputResult"  :value="resultadoUmTresfeiras" disabled>
                    <p class="pResult"> Abono Pecuniário:</p>
                    <input type="text" class="inputResult"  :value="resultadoAbonoPecuniario" disabled>
                    <p class="pResult"> 1/3 Abono Pecuniário:</p>
                    <input type="text" class="inputResult"  :value="resultadoUmTresAbonoPecuniario" disabled>   
                    <p class="pResult">Valor Bruto Férias:</p>
                    <input type="text" class="inputResult"  :value="resultadoValorFeriasBruto" disabled>     
           
                </div>  
                   <div class="col-md-6 col-sm-6">
                    <p class="pResult"> INSS:</p>
                    <input type="text" class="inputResult" :value="resultadoINSS" disabled>
                    <p class="pResult"> IRRF:</p>
                    <input type="text" class="inputResult"  :value="resultadoIRRF" disabled>
                    <p class="pResult"> Total de Descontos:</p>
                    <input type="text" class="inputResult"  :value="resultadoTotalDesconstos" disabled>
                    <p class="pResult"> Valor Líquido Férias:</p>
                    <input type="text" class="inputResult" :value="resultadoValorFeriasLiquido" disabled>    
                             <p class="pResult"> Adiantamento 13º Salário</p>
                    <input type="text" class="inputResult"  :value="resultadoAdiantamentoTreze" disabled>
                </div>          
             </div>
        </div>
  </div>
</template>

<script>
import services from '../services/services.js'
import {Money} from 'v-money';
import topOp from '../shared/topOp.vue';
export default {  
  components:{
    'topOp':topOp,
    Money
  },
  data(){
    return {    
      erro:false,
      spiner:false,
      disabled:false,
      exibirCheck:false,
      exibirCheck2:false,
      abonoPecuniario:0,
      dependentes:0,
      salarioBruto:0,     
      mediaVariaveis1:0,
      mediaVariaveis2:0,
      gozoFerias:0,
      price:null,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false,
          min:0
        },
        resultadoValorFerias:null,
        resultadoUmTresfeiras:null,
        resultadoUmTresAbonoPecuniario:null,
        resultadoAbonoPecuniario:null,
        resultadoDomingosFeriados:null,
        resultadoAdiantamentoTreze:null,
        resultadoValorFeriasBruto:null,
        resultadoINSS:null,
        resultadoIRRF:null,
        resultadoTotalDesconstos:null,
        resultadoValorFeriasLiquido:null,
        exibir:false,
        exibir2:false,
        resRemuneracao:[]
    }
  },
  methods:{
    async calcular(){
      this.disabled = true;
      this.spiner = true;
      let valor  = 0;
      if(this.exibir2 == false){
        valor = -1;
      }else{
        valor  = this.mediaVariaveis2
      }
      this.resRemuneracao = await services.getRemuneracao(this.salarioBruto,this.mediaVariaveis1,this.dependentes,this.gozoFerias,this.abonoPecuniario,valor)
      if(this.resRemuneracao == undefined){
        this.disabled = false;
        this.spiner = false;
        this.erro  = true
        return;
      }
       
      this.resultadoValorFerias =this.resRemuneracao.valorFerias
        this.resultadoUmTresfeiras=this.resRemuneracao.tercoFerias
        this.resultadoUmTresAbonoPecuniario=this.resRemuneracao.tercoPecuniario
        this.resultadoAbonoPecuniario=this.resRemuneracao.valorPecuniario
       this.resultadoAdiantamentoTreze = this.resRemuneracao.adiantar13
        this.resultadoValorFeriasBruto=this.resRemuneracao.feriasBruto
        this.resultadoINSS=this.resRemuneracao.valorINSS
        this.resultadoIRRF=this.resRemuneracao.valorIRRF
        this.resultadoTotalDesconstos =this.resRemuneracao.totalDescontos
        this.resultadoValorFeriasLiquido=this.resRemuneracao.feriasLiquido  
      this.disabled = false;
      this.spiner = false;
            this.erro  = false
    },
    limpar(){
       this.abonoPecuniario=0  
       this.dependentes=0
       this.salarioBruto=0  
       this.mediaVariaveis1=0
       this.mediaVariaveis2=0
       this.gozoFerias=0
        this.resultadoValorFerias =''
        this.resultadoUmTresfeiras=''
        this.resultadoUmTresAbonoPecuniario=''
        this.resultadoAbonoPecuniario=''
       this.resultadoAdiantamentoTreze = ''
        this.resultadoValorFeriasBruto=''
        this.resultadoINSS=''
        this.resultadoIRRF=''
        this.resultadoTotalDesconstos =''
        this.resultadoValorFeriasLiquido=''
        this.erro = false
        this.exibir2 = false;
        this.exibir = false;
    },
    desabilitar(){
       this.exibir = !this.exibir
       if(this.exibir == false){
           this.abonoPecuniario  =  0;
         }
    },
    desabilitar2(){
         this.exibir2 = !this.exibir2
         if(this.exibir2 == false){
           this.mediaVariaveis2  =  0;
         }
    }
  },
  watch:{
    mesAno(novo,velho){                 
        if(novo.length == 3 && !(novo[(novo.length-1)] == '/')){
            this.mesAno = this.mesAno.replace(/(\d{2})/,"$1/")
        }            
        this.mesAno= this.mesAno.replace(/[A-Za-z]/, '')         
        this.mesAno= this.mesAno.replace(/[!@#$%¨&*)(+´^>}{.,|"<;:]/, '') 
        },
  },
}
</script>
<style scoped>

.abonoPecuniario{
    width: 20px;
    height: 20px;
    border:1px solid red;
    display: inline-block;
}
.inputResult{
width: 370px;height: 45px;border-radius:10px;padding-left:10px;
}
.container-flex {        
         display: flex;
         flex-direction: row;
         justify-content: center;
         align-items: center
     }
     .box {
         width: 360px;
        height: 45px;
         background: #fff;
     }
.resultado{
  width: 407px;
height: 45px;
background: #fff;
}
.pResult{
text-align:left;margin-bottom:5px;margin-top:10px;margin-left:40px;
}
.calcular{
  float: right;background: #FF7835 0% 0% no-repeat padding-box;
border: 2px solid #FF7835;
border-radius: 5px;width: 170px;
font-size:21px;
height: 48px;color:#fff;margin-top:-10px;font-weight: 600;cursor:pointer;
font-style:italic;
}
.calcular:hover{
  background: #e64d00;
  border:1px solid #e64d00;
}
.limpar{
  float: left;border: 2px solid #FF7835;
border-radius: 5px;background:#fff;padding:5px;font-weight: 500;font-size:15px;width: 105px;cursor:pointer;font-style:italic;
}
input.formatacaoInput{
  /* border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-radius: 10px;
  height: 43px;
}
.horasExtrasResultado{
  margin-top:40px;
  padding-left:110px;
  padding-right:110px;
  padding-bottom:30px;
  padding-top:30px;
}
.input-group-text{
  border-left: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-radius: 10px;
}
.horasExtras{
  padding-left:110px;
  padding-right:110px;
}
h3{
  border-bottom: 1px solid #707070;
  padding-bottom: 6px;
  text-align: left;
  font-weight: bold;
  font-size:26px;
}
.formAjuste4{
  width: 370px;
  margin:0px auto;
  padding-top:40px;
 
}

input{
  border-right: 1px solid #707070;
    border-top: 1px solid #707070;
    border-bottom: 1px solid #707070;
}
@media only screen and (max-width: 1199px) {
.pResult{
    margin-left:5px;
}
}
@media only screen and (max-width: 967px) {
    .inputResult
    {
        width: 250px
    }
}
@media only screen and (max-width: 767px) {
 .horasExtras{
   margin-top:445px;
 }
 .formAjuste4{
  width: 320px;
 }
 .inputResult
    {
width: 150px
    }
}
@media only screen and (max-width: 767px) {
  .formAjuste4{
  width: 300px;
  margin:20px auto;
}
.horasExtras{
   padding-left:80px;
 }
}
@media only screen and (max-width: 574px) {
.inputResult
    {
width: 340px
    }
    .horasExtrasResultado{
        padding-left: 40px;
    padding-right: 170px;
    }
}
@media only screen and (max-width: 400px) {
  .formAjuste4{
    width: 230px;
    margin:20px auto;
  }
  .limpar{
    width: 88px;
  }
  .calcular{
  width: 126px;
  height: 37px;
  margin-top:0px;
  }
  .inputResult
    {
width: 280px
    }
}
</style>


// WEBPACK FOOTER //
// src/screens/RemuneracaoFerias.vue